// extracted by mini-css-extract-plugin
export default {"rootMyFile":"myFile_rootMyFile__hJ3wy","tabs":"myFile_tabs__l3b94"};